class SsnFormatter
  @SSN_LENGTH: 9

  constructor: (@firstSetLength, @secondSetLength)->

  formatter: ->
    thirdSetLength = @constructor.SSN_LENGTH - @firstSetLength - @secondSetLength
    full_hidden_string = @_repeatAsterisk(@firstSetLength) + '-' +
                         @_repeatAsterisk(@secondSetLength) + '-' +
                         @_repeatAsterisk(thirdSetLength)

    (input) =>
      return "" unless input
      return input if input.length == 1
      return full_hidden_string if input.length == @constructor.SSN_LENGTH

      hidden = @_repeatAsterisk(input.length - 1) + input.slice(-1)

      if hidden.length >= @firstSetLength
        hidden = hidden.slice(0, @firstSetLength) + "-" +
                 hidden.slice(@firstSetLength, hidden.length)

      secondSlicePoint = (@firstSetLength + @secondSetLength + 1)
      if hidden.length >= secondSlicePoint
        hidden = hidden.slice(0, secondSlicePoint) + "-" +
                 hidden.slice(secondSlicePoint, hidden.length)

      hidden

  _repeatAsterisk: (n)->
    new Array(n + 1).join('*')

angular.module("avant.filters").filter "ssn", ->
  new SsnFormatter(3, 2).formatter()

angular.module("avant.filters").filter "sinCa", ->
  new SsnFormatter(3, 3).formatter()
